import { FlightsSearchFilterValuesInput } from '__generated__/api';

export const compareFilterValues = (
  keyForFilterInUrl,
  keyForFilterValueFromUrl,
  filterValueFromUrl,
  secondObject
): boolean => {
  let filterFound = false;
  (secondObject as FlightsSearchFilterValuesInput[]).forEach(filterValueList => {
    const keyForFilterInCriteria = Object.keys(filterValueList)[0];
    const keyForFilterValueFromCriteria = Object.keys(filterValueList[keyForFilterInCriteria])[0];
    const filterValueFromCriteria = filterValueList[keyForFilterInCriteria][keyForFilterValueFromCriteria];
    if (filterFound) {
      return;
    }

    if (
      keyForFilterInUrl !== keyForFilterInCriteria ||
      keyForFilterValueFromCriteria !== keyForFilterValueFromUrl ||
      typeof filterValueFromCriteria !== typeof filterValueFromUrl
    ) {
      return;
    }

    if (typeof filterValueFromCriteria === 'string' && filterValueFromCriteria === filterValueFromUrl) {
      filterFound = true;

      return;
    }

    if (typeof filterValueFromCriteria === 'number' && filterValueFromCriteria === filterValueFromUrl) {
      filterFound = true;

      return;
    }

    if (typeof filterValueFromCriteria === 'object') {
      const keyForNestedFilterOperationFromUrl = Object.keys(filterValueFromUrl)[0];
      const keyForNestedFilterValueFromUrl = Object.keys(filterValueFromUrl)[1];

      const filterNestedOperationFromCriteria = filterValueFromCriteria[keyForNestedFilterOperationFromUrl];
      const filterNestedOperationFromUrl = filterValueFromUrl[keyForNestedFilterOperationFromUrl];

      const filterNestedValueFromCriteria = filterValueFromCriteria[keyForNestedFilterValueFromUrl];
      const filterNestedValueFromUrl = filterValueFromUrl[keyForNestedFilterValueFromUrl];

      if (
        filterNestedOperationFromCriteria === filterNestedOperationFromUrl &&
        filterNestedValueFromCriteria === filterNestedValueFromUrl
      ) {
        filterFound = true;
      }
    }
  });

  return filterFound;
};
